<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{ translateTitleCase("userAction.listPageTitle") }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration">
        <template #cell-createdAt="{ item }">
          <div
            class="cursor-pointer text-overflow-ellipsis max-width-200"
            style="
              display: inline-block;
              direction: ltr;
              unicode-bidi: bidi-override;
              text-align: start;
            ">
            <span>{{ translateDate(item?.createdAt, "dateWithTime") }}</span>
          </div>
        </template>
        <template #cell-UserGroups="{ item }">
          <div
            class="cursor-pointer text-overflow-ellipsis max-width-300 flex gap-s flex-wrap"
            v-tooltip="{
              content: getUserGroupString(item),
              translate: false,
            }">
            <badge
              size="s"
              v-for="group of getSafeUserGroups(item)"
              :text="group?.name"></badge>
          </div>
        </template>
        <template #cell-performedActionType="{ item }">
          <div
            v-tooltip="{
              content: `${getActionTypeTranslation(item.actionType)} (${
                item.actionType
              })`,
              translate: false,
            }"
            class="cursor-pointer text-overflow-ellipsis max-width-200">
            <span>{{ getActionTypeTranslation(item.actionType) }}</span>
          </div>
        </template>
        <template #cell-OwnerId="{ item }">
          <div
            v-tooltip="{
              content: `${item?.Owner?.fullName} (${item?.Owner?.email})`,
              translate: false,
            }"
            class="cursor-pointer text-overflow-ellipsis max-width-200">
            <span>{{
              `${item?.Owner?.email} (${item?.Owner?.fullName})`
            }}</span>
          </div>
        </template>
        <template #cell-params="{ item }">
          <div
            class="cursor-pointer text-overflow-ellipsis max-width-300 flex gap-s flex-wrap">
            <span class="force-ltr">{{ item.params }}</span>
          </div>
        </template>
      </custom-crud-list>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";

export default {
  components: { CustomCrudList },
  layout: "adminDashboard",

  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "userAction.listPageMetaTitle",
  data: function () {
    return {
      currentConversationUuid: null,
      listConfiguration: {
        subject: "userAction",
        listSrc: "user-action",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        editRoute: (item) => {
          return this.$router.push({
            name: "admin-entity-entityType-edit-entityId",
            params: {
              entityType: "userAction",
              entityId: item.id,
            },
          });
        },
        createRoutePrefix: "admin-entity-",
        deleteRoutePrefix: "entity/",
        additionalGetListData: {
          with: ["owner", "owner.userGroups"],
        },
        fields: {
          // these are the table columns
          createdFrom: {
            itemKey: "createdFrom",
            label: "userAction.fields.createdFrom",
            listable: false,
            filterable: {
              name: "createdFrom",
              type: "datePicker",
              placeholder: "userAction.fields.createdFrom",
            }, //
            orderable: true,
          },
          createdUntil: {
            itemKey: "createdUntil",
            label: "userAction.fields.createdUntil",
            listable: false,
            filterable: {
              name: "createdUntil",
              type: "datePicker",
              placeholder: "userAction.fields.createdUntil",
            }, //
            orderable: true,
          },
          createdAt: {
            itemKey: "createdAt",
            label: "userAction.fields.createdAt",
          },
          performedActionType: {
            itemKey: "actionType",
            label: "userAction.fields.actionType",
            filterable: {
              name: "performedActionType",
              placeholder: "userAction.fieldFilters.performedActionType",
              type: "Select2",
              itemComponent: "iconItem",
              asyncListSource: "user-action/action/list",
              asyncListLive: false,
              textFilterAsSaffronListFilter: false,
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
            orderable: true,
          },
          didNotPerformActionType: {
            itemKey: "actionType",
            label: "userAction.fields.actionType",
            listable: false,
            filterable: {
              name: "didNotPerformActionType",
              placeholder: "userAction.fieldFilters.didNotPerformActionType",
              type: "Select2",
              itemComponent: "iconItem",
              asyncListSource: "user-action/action/list",
              asyncListLive: false,
              textFilterAsSaffronListFilter: false,
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
            orderable: true,
          },
          OwnerId: {
            itemKey: "OwnerId",
            label: "userAction.fields.OwnerId",
            filterable: {
              name: "OwnerId",
              type: "Select2",
              placeholder: "userAction.fields.OwnerId",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              itemComponent: "iconItem",
              asyncListSource: "entity/User",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "fullName",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          UserGroups: {
            itemKey: "UserGroups",
            label: "userAction.fieldFilters.userGroups",
            filterable: {
              name: "UserGroup",
              type: "Select2",
              placeholder: "userAction.fieldFilters.userGroups",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              itemComponent: "iconItem",
              asyncListSource: "entity/UserGroup",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "name",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          params: {
            itemKey: "params",
            label: "userAction.fields.params",
          },
          /*
           note: {
           itemKey: "note",
           label: "userAction.fields.note",
           },
           */
        },
        actions: {
          show: false,
          edit: true,
          delete: true,
          create: false,
          custom: {
            /*
             showChat: {
             //tooltip
             tooltip: { content: "userAction.showChatTooltip" },
             icon: "eye",
             theme: "inverse",
             //text
             handler: async ({ item }) => {
             this.currentConversationUuid = item.Conversation.uuid;
             console.log("show chat");
             console.log(item);
             },
             },
             */
          },
        },
      },
      asyncData: {},
    };
  },
  computed: {},
  methods: {
    getSafeUserGroups(item) {
      let groups = item?.Owner?.UserGroups;

      return Array.isArray(groups) ? groups : [];
    },
    getUserGroupString(item) {
      let groups = item?.Owner?.UserGroups;

      if (!Array.isArray(groups) || groups.length < 1) {
        return "-";
      }

      return groups.map((group) => group.name).join(", ");
    },
    getActionTypeTranslation(type) {
      return this.t(`userAction.actionTypes.${type}`);
    },
  },
};
</script>
